import React, { useMemo } from "react";
import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import { ReactComponent as SystemIcon } from "asset/system_icon.svg"
import { ReactComponent as DashboardIcon } from "asset/dashboard_icon.svg"
import style from "css/admin/component.module.css";
import { ReactComponent as LicenseManageIcon } from "asset/license_manage_icon.svg"
import { ReactComponent as AdminManageIcon } from "asset/admin_manage_icon.svg"
import { AppstoreAddOutlined, UserOutlined } from "@ant-design/icons";

const allItems = [
    { key: "application", icon: <LicenseManageIcon className="menu-icon" />, label: "라이선스 신청 관리", path: "application" },
    { key: "system", icon: <SystemIcon className="menu-icon" />, label: "신청 기간 관리", path: "system" },
    { key: "dashboard", icon: <DashboardIcon className="menu-icon" />, label: "대시보드", path: "dashboard" },
    { key: "product", icon: <AppstoreAddOutlined className="menu-icon" />, label: "제품 관리", path: "product" },
    { key: "user", icon: <UserOutlined className="menu-icon" />, label: "사용자 관리", path: "user" },
    { key: "admin", icon: <AdminManageIcon className="menu-icon" />, label: "관리자 목록", path: "admin", ownerOnly: true },
];

function AdminSideMenu() {
    const location = useLocation();
    const navigate = useNavigate();
    const adminType = useSelector((state) => state.user.adminType);

    const items = useMemo(() => {
        const isOwner = adminType === "CD0101";
        return allItems.filter((item) => !item.ownerOnly || isOwner);
    }, [adminType]);

    const selectedKey =
        items.find((i) => location.pathname.includes(`/admin/${i.path}`))?.key

    return (
        <Layout.Sider
            width={240}
            className={style.sidemenu}
        >
            <ConfigProvider
                theme={{
                    components: {
                        Menu: {
                            itemColor: "#111",
                            itemSelectedColor: "#fff",
                            itemSelectedBg: "#527ff2",
                            itemHeight: 45,
                        },
                    },
                }}
            >
                <Menu
                    className={style.menu}
                    mode="inline"
                    selectedKeys={[selectedKey]}
                    items={items}
                    onClick={({ key }) => {
                        const target = items.find((i) => i.key === key);
                        if (target) {
                            navigate(`/admin/${target.path}`);
                        }
                    }}
                />
            </ConfigProvider>
        </Layout.Sider>
    );
}

export default AdminSideMenu;

